import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "src/app/services/common.service";
import { GlobalVariable } from "../../../app.component";
import { DataService, Response } from "./../../../dataService/data.service";
@Component({
  selector: "app-top-tile-one",
  templateUrl: "./top-tile-one.component.html",
  styleUrls: [
    "./top-tile-one.component.scss",
    "./../../monthly-reviews/monthly-reviews.component.scss",
  ],
})
export class TopTileOneComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  appointmentDetail: any;
  isAppointment;
  mystoreDetail: any;
  outlet_id: string;
  @Input() mystoreData: any;
  @Input() isAnyAppointmentData: boolean;

  constructor(
    private router: Router,
    private HttpService: DataService,
    private commonService: CommonService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    console.log(this.outlet_id);
    console.log(this.router.url);
    if (this.router.url === "/dashboard/appointments") {
      this.getAppointmentDetails();
    }
  }

  getAppointmentDetails() {
    let res: Response;
    this.commonService.appointment_top_panel.subscribe((data) => {
      res = data;
      if (res) {
        if (res.code === 200) {
          // console.log(res.data);
          this.isAppointment = true;
          this.appointmentDetail = res.data;
          this.loading = false;
        }
      }
    });
  }

  redirectToAppointment() {
    this.router.navigate([`/appointments`]);
  }
}
